import { useMedia } from '@avalenti89/react-ts-utils';

export const breakpoints = {
	xxs: 360,
	xs: 576,
	sm: 768,
	md: 992,
	lg: 1200,
	xl: 2048,
	xxl: 3840,
};

export const useBreakpoint = () => {
	const breakpoint = useMedia(breakpoints);
	return {
		breakpoint,
		isMobile: breakpoint ? ['xxs', 'xs'].includes(breakpoint) : false,
		isTablet: breakpoint ? ['sm', 'md'].includes(breakpoint) : false,
	};
};
